import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { API, UPLOADS } from "./../../config/api";

export default function AddWorkspace() {
  const navigate = useNavigate();
  const location = useLocation();
  const [errors, setErrors] = useState({});
  const [renewPopup, setRenewPopup] = useState(false);
  const [renewWorkspaceId, setRenewWorkspaceId] = useState("");
  const existingData = location.state?.workspace || null;
  const isEditMode = !!existingData;
  const [adsPlans, setAdsPlans] = useState([]);
  const [renewData, setRenewData] = useState({
    show_ads_days: "",
    ads_amount: "",
    payment_screenshot: null,
  });
  useEffect(() => {
    fetch(API.GET_ADS_PLANS)
      .then((res) => res.json())
      .then((data) => {
        if (data.status) {
          setAdsPlans(data.data);
        }
      });
  }, []);
  useEffect(() => {
    const interval = setInterval(() => {
      setTick((t) => t + 1);
    }, 1000);

    return () => clearInterval(interval);
  }, []);
  const hasUsedFreePlan = (item) => {
    return Number(item.workspace_free_plan_used) === 1;
  };
  const fetchWorkspace = async () => {
    const user = JSON.parse(sessionStorage.getItem("user"));

    if (!user?.id) return;

    try {
      const res = await fetch(
        `${API.LIST_WORKSPACES}&user_id=${user.id}&t=${Date.now()}`,
      );

      const data = await res.json();

      const formattedData = Array.isArray(data)
        ? data.map((item) => ({
            ...item,
            images: item.image
              ? item.image.split(",").filter((img) => img && img.trim() !== "")
              : [],
          }))
        : [];

      setWorkspace(formattedData);
    } catch (error) {
      console.error(error);
    }
  };
  useEffect(() => {
    fetchWorkspace();
  }, []);
  const [form, setForm] = useState({
    id: "",
    owner_name: "",
    phone: "",
    address: "",
    city: "",
    state: "",
    size: "",
    width: "",
    height: "",
    floor: "",
    rent_price: "",
    location: "",
    description: "",
    images: [],
    show_ads_days: "",
    ads_amount: "",
    payment_screenshot: null,
  });
  const [workspace, setWorkspace] = useState([]);
  const [viewData, setViewData] = useState(null);
  const [tick, setTick] = useState(0);
  const [loading, setLoading] = useState(false);
  const [previewImage, setPreviewImage] = useState(null);
  const getTimeLeft = (expiryDate, status) => {
    // Don't show timer for PENDING machines
    if (status?.toLowerCase() === "pending") return null;

    if (!expiryDate) return null;

    const now = new Date().getTime();
    const expiry = new Date(expiryDate.replace(" ", "T")).getTime();
    const diff = expiry - now;

    if (diff <= 0) return "Expired";

    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
    const mins = Math.floor((diff / (1000 * 60)) % 60);

    return `${days}d ${hours}h ${mins}m`;
  };
  const handleChange = (e) => {
    const { name, value, type } = e.target;

    // 1. Handle Screenshot Upload FIRST
    if (name === "payment_screenshot") {
      setForm((prev) => ({
        ...prev,
        payment_screenshot: e.target.files[0],
      }));
      return;
    }

    // 2. Handle Workspace Images
    // 2. Handle Workspace Images
    if (type === "file" && name === "images") {
      const files = Array.from(e.target.files);

      if (files.length === 0) return;

      // Get current images (exclude any previously selected Files that were already added)
      const currentImages = form.images || [];

      // Create array of existing file names to check for duplicates
      const existingFileNames = currentImages
        .map((img) => (img instanceof File ? img.name : img))
        .filter(Boolean);

      // Filter out duplicates and limit to 4 total
      const newFiles = files.filter((file) => {
        const isDuplicate = existingFileNames.includes(file.name);
        return !isDuplicate;
      });

      // Combine existing + new files (max 4)
      const combinedImages = [...currentImages, ...newFiles].slice(0, 4);

      // Check if we hit the limit
      if (combinedImages.length >= 4 && files.length > 0) {
        setErrors((prev) => ({
          ...prev,
          images: "Maximum 4 images allowed",
        }));
      } else {
        setErrors((prev) => ({
          ...prev,
          images: "",
        }));
      }

      setForm((prev) => ({
        ...prev,
        images: combinedImages,
      }));

      // Clear input so same file can be selected again if needed
      e.target.value = null;
      return;
    }
    if (name === "width" || name === "height") {
      if (!/^[0-9]{0,4}$/.test(value)) return;
    }

    if (name === "show_ads_days") {
      const selectedPlan = adsPlans.find(
        (p) => String(p.days) === String(value),
      );

      setForm((prev) => ({
        ...prev,
        show_ads_days: value,
        ads_amount: selectedPlan ? selectedPlan.amount : "",
      }));

      return;
    }
    // Phone Validation
    if (name === "phone") {
      if (!/^[0-9]{0,10}$/.test(value)) return;

      if (value.length !== 10) {
        setErrors((prev) => ({
          ...prev,
          phone: "Phone number must be 10 digits",
        }));
      } else {
        setErrors((prev) => ({
          ...prev,
          phone: "",
        }));
      }
    }
    if (name === "payment_screenshot") {
      setForm((prev) => ({
        ...prev,
        payment_screenshot: e.target.files[0],
      }));

      return;
    }
    if (name === "payment_screenshot") {
      setForm((prev) => ({
        ...prev,
        payment_screenshot: e.target.files[0],
      }));

      return;
    }
    if (name === "payment_screenshot") {
      setForm((prev) => ({
        ...prev,
        payment_screenshot: e.target.files[0],
      }));

      return;
    }

    // Room Size Validation (20 x 40)
    if (name === "size") {
      const regex = /^\d{0,4}(\s?x\s?\d{0,4})?$/i;

      if (!regex.test(value)) return;

      if (value && !/^\d+\s?x\s?\d+$/.test(value)) {
        setErrors((prev) => ({
          ...prev,
          size: "Enter size like 20 x 40",
        }));
      } else {
        setErrors((prev) => ({
          ...prev,
          size: "",
        }));
      }
    }

    setForm({
      ...form,
      [name]: value,
    });
  };
  const removeImage = (index) => {
    const newImages = [...form.images];
    newImages.splice(index, 1);

    setForm({ ...form, images: newImages });

    if (newImages.length === 0) {
      setErrors((prev) => ({
        ...prev,
        images: "Please upload at least 1 image",
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault(); // ✅ MUST BE FIRST

    if (errors.phone || errors.size) {
      alert("Please fix validation errors");
      return;
    }

    // Image Validation (Minimum 1)
    if (form.images.length === 0) {
      setErrors((prev) => ({
        ...prev,
        images: "Please upload at least 1 image",
      }));
      return;
    }

    if (loading) return;
    setLoading(true);

    const formData = new FormData();
    const user = JSON.parse(sessionStorage.getItem("user"));

    formData.append("user_id", user?.id || "");
    formData.append("owner_name", form.owner_name);
    formData.append("phone", form.phone);
    formData.append("city", form.city);
    formData.append("state", form.state);
    formData.append("address", form.address);
    const sizeValue =
      form.width && form.height ? `${form.width} x ${form.height}` : "";

    formData.append("size", sizeValue); // ✅ ADD THIS LINE
    formData.append("floor", form.floor);
    formData.append("rent_price", form.rent_price);
    formData.append("location", form.location);
    formData.append("description", form.description);
    formData.append("show_ads_days", form.show_ads_days || "");
    formData.append("ads_amount", form.ads_amount || "");

    // ✅ PAYMENT SCREENSHOT
    if (form.payment_screenshot) {
      formData.append("payment_screenshot", form.payment_screenshot);
    }
    if (existingData) {
      formData.append("id", form.id);
    }

    form.images.forEach((img) => {
      if (img instanceof File) {
        formData.append("images[]", img);
      } else {
        formData.append("existing_images[]", img);
      }
    });

    const url = existingData ? API.UPDATE_WORKSPACE : API.ADD_WORKSPACE;

    try {
      const res = await fetch(url, {
        method: "POST",
        body: formData,
      });

      const data = await res.json();

      if (data.status === "success") {
        alert(
          existingData
            ? "Workspace Updated Successfully!"
            : "Workspace Inserted Successfully!",
        );

        // ✅ REFRESH LATEST DATA FROM DB
        await fetchWorkspace();

        setForm({
          id: "",
          owner_name: "",
          phone: "",
          address: "",
          city: "",
          state: "",
          size: "",
          width: "",
          height: "",
          floor: "",
          rent_price: "",
          location: "",
          description: "",
          images: [],
          show_ads_days: "",
          ads_amount: "",
          payment_screenshot: null,
        });

        navigate("/admin/add-workspace", { replace: true });
      } else {
        alert(data.message || "Something went wrong");
      }
    } catch (error) {
      console.error(error);
      alert("Error connecting to server");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (existingData) {
      setForm({
        id: existingData.id || "",
        owner_name: existingData.owner_name || "",
        phone: existingData.phone || "",
        address: existingData.address || "",
        city: existingData.city || "",
        state: existingData.state || "",
        width: existingData.size ? existingData.size.split("x")[0].trim() : "",
        height: existingData.size
          ? existingData.size.split("x")[1]?.trim()
          : "",
        floor: existingData.floor || "",
        rent_price: existingData.rent_price || "",
        location: existingData.location || "",
        description: existingData.description || "",
        images: existingData.image ? existingData.image.split(",") : [],
        show_ads_days: existingData.show_ads_days || "",
        ads_amount: existingData.ads_amount || "",
        payment_screenshot: null,
      });
    }
  }, [existingData]);

  // useEffect(() => {
  //   if (existingData) {
  //     setForm({
  //       id: existingData.id || "",
  //       owner_name: existingData.owner_name || "",
  //       phone: existingData.phone || "",
  //       address: existingData.address || "",
  //       city: existingData.city || "",
  //       state: existingData.state || "",
  //       width: existingData.size ? existingData.size.split("x")[0].trim() : "",

  //       height: existingData.size
  //         ? existingData.size.split("x")[1]?.trim()
  //         : "",
  //       floor: existingData.floor || "",
  //       rent_price: existingData.rent_price || "",
  //       location: existingData.location || "",
  //       description: existingData.description || "",
  //       images: existingData.image ? existingData.image.split(",") : [],
  //       show_ads_days: existingData.show_ads_days || "",
  //       ads_amount: existingData.ads_amount || "",
  //       payment_screenshot: null,
  //     });
  //   }
  // }, [existingData]);

  useEffect(() => {
    fetchWorkspace();
  }, [location.pathname]);
  const isExpired = (item) => {
    if (!item.ads_end_date) return false;

    return new Date(item.ads_end_date).getTime() < Date.now();
  };

  const handleDelete = async (id) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this workspace?",
    );

    if (!confirmDelete) return;

    try {
      const formData = new FormData();
      formData.append("id", id);

      const res = await fetch(API.DELETE_WORKSPACE, {
        method: "POST",
        body: formData,
      });
      const data = await res.json();

      if (data.status === "success") {
        alert("Workspace Deleted Successfully");

        setWorkspace((prev) => prev.filter((item) => item.id !== id));
      } else {
        alert(data.message || "Delete failed");
      }
    } catch (error) {
      console.error(error);
      alert("Server Error");
    }
  };
  const handleRenewChange = (e) => {
    const { name, value, files } = e.target;

    if (name === "show_ads_days") {
      const selectedPlan = adsPlans.find(
        (p) => String(p.days) === String(value),
      );

      setRenewData({
        ...renewData,
        show_ads_days: value,
        ads_amount: selectedPlan ? selectedPlan.amount : "",
      });

      return;
    }

    if (name === "payment_screenshot") {
      setRenewData({
        ...renewData,
        payment_screenshot: files[0],
      });

      return;
    }
  };
  const handleRenewSubmit = async () => {
    // FIND CURRENT WORKSPACE
    const currentWorkspace = workspace.find(
      (item) => String(item.id) === String(renewWorkspaceId),
    );

    // FREE PLAN VALIDATION
    if (
      renewData.ads_amount === "0" &&
      Number(currentWorkspace?.workspace_free_plan_used) === 1
    ) {
      alert("You already used free plan");
      return;
    }

    // PLAN VALIDATION
    if (!renewData.show_ads_days) {
      alert("Please select plan");
      return;
    }

    // PAYMENT VALIDATION
    if (renewData.ads_amount !== "0" && !renewData.payment_screenshot) {
      alert("Upload payment screenshot");
      return;
    }

    const formData = new FormData();

    formData.append("id", renewWorkspaceId);
    formData.append("show_ads_days", renewData.show_ads_days);
    formData.append("ads_amount", renewData.ads_amount);

    if (renewData.payment_screenshot) {
      formData.append("payment_screenshot", renewData.payment_screenshot);
    }

    const res = await fetch(API.RENEW_ADS, {
      method: "POST",
      body: formData,
    });

    const data = await res.json();

    if (data.status === "error") {
      alert(data.message);
      return;
    }

    alert(data.message);

    setRenewPopup(false);

    fetchWorkspace();
  };
  return (
    <div className="workspace-container">
      <h2 className="machine-title">
        {existingData ? "Edit Workspace" : "Add Workspace"}
      </h2>

      <form onSubmit={handleSubmit} className="workspace-form">
        {/* Owner Section */}
        <div className="workspace-section">
          <h3>Workspace Details</h3>
          <hr />
        </div>

        <div className="workspace-grid">
          <div className="row">
            <div className="col-md-6">
              {" "}
              <div className="workspace-field-small">
                <label>Owner Name</label>
                <input
                  name="owner_name"
                  placeholder="Enter owner full name"
                  value={form.owner_name}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className="workspace-field-small">
                <label>Mobile Number</label>
                <input
                  name="phone"
                  placeholder="Enter mobile number (e.g. 9876543210)"
                  value={form.phone}
                  onChange={handleChange}
                  required
                />
                {errors.phone && <span className="error">{errors.phone}</span>}
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6">
              <div className="workspace-field-3">
                <label>Office Address</label>
                <textarea
                  name="address"
                  placeholder="Enter full workspace address"
                  value={form.address}
                  onChange={handleChange}
                />
              </div>
            </div>
            <div className="col-md-6">
              {" "}
              <div className="workspace-field-small">
                <label>Landmark</label>
                <input
                  name="location"
                  placeholder="Nearby landmark (e.g. Ring Road, Textile Market)"
                  value={form.location}
                  onChange={handleChange}
                />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-6">
              {" "}
              <div className="workspace-field-small">
                <label>City</label>
                <input
                  name="city"
                  placeholder="Enter city (e.g. Surat)"
                  value={form.city}
                  onChange={handleChange}
                />
              </div>
            </div>

            <div className="col-md-6">
              {" "}
              <div className="workspace-field-small">
                <label>State</label>
                <input
                  name="state"
                  placeholder="Enter state (e.g. Gujarat)"
                  value={form.state}
                  onChange={handleChange}
                />
              </div>
            </div>
          </div>
          {/* </div> */}

          {/* Room Section */}
          {/* <div className="workspace-section">
          <h3>Workspace Details</h3>
          <hr />
        </div> */}

          {/* <div className="workspace-grid"> */}
          <div className="row">
            <div className="col-md-6">
              {" "}
              <div className="workspace-field-small">
                <label>Floor</label>
                <input
                  name="floor"
                  placeholder="e.g. 2nd Floor"
                  value={form.floor}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className="workspace-field-small">
                <label>Rent Price</label>
                <input
                  name="rent_price"
                  placeholder="Enter monthly rent (e.g. 15000)"
                  value={form.rent_price}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6">
              <div className="workspace-field-small">
                <label>Room Size (Feet)</label>
                <div style={{ display: "flex", gap: "10px" }}>
                  <input
                    name="width"
                    value={form.width}
                    onChange={handleChange}
                    placeholder="Width (e.g. 20)"
                  />

                  <span style={{ alignSelf: "center" }}>x</span>

                  <input
                    name="height"
                    value={form.height}
                    onChange={handleChange}
                    placeholder="Length (e.g. 40)"
                  />
                </div>
                {errors.size && <span className="error">{errors.size}</span>}
              </div>
            </div>
            <div className="col-md-6">
              <div className="workspace-field-3">
                <label>Description</label>
                <textarea
                  name="description"
                  placeholder="Describe workspace facilities, machines, electricity, parking etc."
                  value={form.description}
                  onChange={handleChange}
                />
              </div>
            </div>
          </div>

          {/* Upload */}
          {/* <div className="workspace-field">
            <label>Upload Images (Max 4)</label>

            <input
              type="file"
              multiple
              accept="image/*"
              onChange={handleChange}
              disabled={form.images.length >= 4}
            />

         
            {errors.images && <span className="error">{errors.images}</span>}
          </div>

        
          <div className="workspace-preview">
            {form.images.map((img, index) => (
              <div key={index} className="workspace-preview-box">
                <img
                  src={
                    img instanceof File
                      ? URL.createObjectURL(img)
                      : `${UPLOADS.WORKSPACE_IMAGE}${img}`
                  }
                  alt="preview"
                />
                <button type="button" onClick={() => removeImage(index)}>
                  ✕
                </button>
              </div>
            ))}
          </div> */}
          <div className="workspace-field">
            <label>Upload Images (Max 4)</label>

            <input
              type="file"
              name="images" // ← THIS IS IMPORTANT
              multiple
              accept="image/*"
              onChange={handleChange}
              disabled={form.images.length >= 4}
            />

            {errors.images && <span className="error">{errors.images}</span>}
          </div>
          <div className="workspace-preview">
            {form.images.map((img, index) => (
              <div key={index} className="workspace-preview-box">
                <img
                  src={
                    img instanceof File
                      ? URL.createObjectURL(img)
                      : `${UPLOADS.WORKSPACE_IMAGE}${img}`
                  }
                />

                <button type="button" onClick={() => removeImage(index)}>
                  ✕
                </button>
              </div>
            ))}
          </div>
          <div className="row">
            <div className="col-md-6">
              {" "}
              <div className="workspace-field">
                <label>Show Ads For</label>
                <select
                  name="show_ads_days"
                  value={form.show_ads_days}
                  onChange={handleChange}
                  disabled={isEditMode}
                  className={form.show_ads_days ? "active" : ""}
                  required
                >
                  <option value="" disabled hidden>
                    Select Days
                  </option>
                  {adsPlans.map((plan) => (
                    <option key={plan.id} value={plan.days}>
                      {plan.days} Days - ₹{plan.amount}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="col-md-6">
              <div className="workspace-field">
                <label>Amount Pay</label>

                <input
                  value={form.ads_amount}
                  readOnly
                  disabled={
                    form.status === "ACTIVE" &&
                    getTimeLeft(form.ads_end_date) !== "Expired"
                  }
                />
              </div>
            </div>
          </div>

          {form.show_ads_days && form.ads_amount !== "0" && (
            <div className="workspace-field">
              <label>Scan & Pay</label>
              <img src="/images/payment1.png" width="200" alt="QR" />
              <p className="pay">OR</p>
              <img src="/images/payment2.png" width="200" alt="QR" />
              <a
                href={`https://wa.me/919909614445?text=${encodeURIComponent(
                  "Hello, I have completed the payment. I am sending the screenshot for verification.",
                )}`}
                target="_blank"
                rel="noopener noreferrer"
                className="whatsapp-btn"
              >
                <i className="bi bi-whatsapp"></i>
                Send Screenshot on WhatsApp
              </a>
            </div>
          )}
          {!isEditMode && form.show_ads_days && form.ads_amount !== "0" && (
            <div className="workspace-field">
              <label>Upload Payment Screenshot</label>

              <input
                type="file"
                name="payment_screenshot"
                onChange={handleChange}
              />
            </div>
          )}
        </div>
        <div className="workspace-action-row">
          {/* <div className="d-flex gap-2 mt-3"> */}

          {/* CANCEL EDIT */}
          {isEditMode && (
            <button
              type="button"
              className="btn-cancel-edit"
              onClick={() => {
                navigate("/admin/add-workspace");
                window.location.reload();
              }}
            >
              <i className="bi bi-x-circle me-2"></i>
              Cancel Edit
            </button>
          )}
          <button className="btn-submit-workspace" disabled={loading}>
            {loading
              ? "Processing..."
              : existingData
                ? "Update Workspace"
                : "Add Workspace"}
          </button>
        </div>
      </form>
      {/* WORKSPACE CARDS */}
      <div className="designs-grid">
        {workspace.length > 0 ? (
          workspace.map((item) => (
            <div className="design-card" key={item.id}>
              {/* IMAGE */}
              <div className="machine-img-container">
                {item.images[0] && (
                  <img
                    src={`${UPLOADS.WORKSPACE_IMAGE}${item.images[0]}`}
                    alt="workspace"
                  />
                )}
              </div>

              {/* BODY */}
              <div className="machine-body">
                <h4 className="machine-name">{item.location}</h4>

                {/* RENT */}
                <div className="d-flex align-items-center justify-content-between mt-2">
                  <div className="price-block">
                    <span className="currency-symbol">₹</span>

                    <span className="amount">
                      {Number(item.rent_price || 0).toLocaleString("en-IN")}
                    </span>
                  </div>

                  <button className="contact-btn">
                    <i className="bi bi-telephone-fill me-1"></i>
                    Contact
                  </button>
                </div>

                {/* SIZE */}
                <div className="spec-row mt-2">
                  <div className="spec-item">
                    <span className="spec-label">Size:</span>

                    <span className="spec-value">{item.size}</span>
                  </div>

                  <div className="spec-item">
                    <span className="spec-label">Floor:</span>

                    <span className="spec-value">{item.floor}</span>
                  </div>
                </div>

                {/* LOCATION */}
                <div className="location-info">
                  <i className="bi bi-geo-alt-fill"></i>
                  {item.city}, {item.state}
                </div>

                {/* STATUS */}
                {/* <div className="mt-2">
                  {!isExpired(item) ? (
                    <span className={`status ${item.status?.toLowerCase()}`}>
                      {item.status}
                    </span>
                  ) : (
                    <span className="status expired">Expired</span>
                  )}
                </div> */}

                {/* ADS INFO */}

                {/* <small>
                    Ads Days: <b>{item.show_ads_days || 0}</b>
                  </small>

                  <br />

                  <small>
                    Amount: <b>₹{item.ads_amount || 0}</b>
                  </small> */}

                {/* TIMER */}
                {/* {!isExpired(item) ? (
                  item.ads_end_date && (
                    <div style={{ color: "green", fontWeight: "bold" }}>
                      Time Left: {getTimeLeft(item.ads_end_date, item.status)}
                    </div>
                  )
                ) : (
                  <div style={{ color: "red", fontWeight: "bold" }}>
                    Ads Expired
                  </div>

                  
                )} */}

                <div className="mt-2">
                  {!isExpired(item) && (
                    <span className={`status ${item.status?.toLowerCase()}`}>
                      {item.status}
                    </span>
                  )}
                </div>
                <div className="mt-3"></div>
                {!isExpired(item) ? (
                  item.ads_end_date && (
                    <div style={{ color: "green", fontWeight: "bold" }}>
                      Time Left: {getTimeLeft(item.ads_end_date, item.status)}
                    </div>
                  )
                ) : (
                  <button
                    className="renew-btn"
                    onClick={() => {
                      setRenewWorkspaceId(item.id);

                      setRenewData({
                        show_ads_days: "",
                        ads_amount: "",
                        payment_screenshot: null,
                      });

                      // store selected workspace
                      setViewData(item);

                      setRenewPopup(true);
                    }}
                  >
                    <i className="bi bi-arrow-clockwise me-2"></i> Renew Ads
                  </button>
                )}

                {/* ACTION */}
                <div className="machine-actions mt-3 d-flex gap-2">
                  {/* VIEW */}
                  <button
                    className="action-btn view-action"
                    onClick={() => setViewData(item)}
                  >
                    <i className="bi bi-eye-fill"></i>
                  </button>

                  {/* EDIT */}
                  <button
                    className="action-btn edit-action"
                    onClick={() =>
                      navigate("/admin/add-workspace", {
                        state: { workspace: item },
                      })
                    }
                  >
                    <i className="bi bi-pencil-fill"></i>
                  </button>

                  {/* DELETE */}
                  <button
                    className="action-btn delete-action"
                    onClick={() => handleDelete(item.id)}
                  >
                    <i className="bi bi-trash-fill"></i>
                  </button>
                </div>
              </div>
            </div>
          ))
        ) : (
          <p>No Workspaces Found</p>
        )}
      </div>
      {/* VIEW POPUP */}
      {viewData && (
        <div className="popup-overlay">
          <div className="popup-box">
            <div className="popup-header">
              <h3>Workspace Details</h3>

              <button
                className="close-icon-btn"
                onClick={() => setViewData(null)}
              >
                ✕
              </button>
            </div>

            <div className="popup-grid">
              <div>
                <label>Owner</label>
                <p>{viewData.owner_name}</p>
              </div>

              <div>
                <label>Mobile</label>
                <p>{viewData.phone}</p>
              </div>

              <div>
                <label>City</label>
                <p>{viewData.city}</p>
              </div>
              <div>
                <label>Address</label>
                <p>{viewData.address}</p>
              </div>

              <div>
                <label>Floor</label>
                <p>{viewData.floor}</p>
              </div>

              <div>
                <label>Rent</label>
                <p>₹ {viewData.rent_price}</p>
              </div>

              <div>
                <label>Ads Duration</label>
                <p>{viewData.show_ads_days}</p>
              </div>

              <div>
                <label>Payed Amount</label>
                <p>₹ {viewData.ads_amount || 0}</p>
              </div>

              {viewData.payment_screenshot && (
                <div>
                  <label>Payment:</label>

                  <img
                    src={`${UPLOADS.WORKSPACE_IMAGE}${viewData.payment_screenshot}`}
                    width="80"
                    alt="payment"
                    style={{
                      cursor: "pointer",
                      borderRadius: "8px",
                      border: "1px solid #ddd",
                    }}
                    onClick={() =>
                      setPreviewImage(
                        `${UPLOADS.WORKSPACE_IMAGE}${viewData.payment_screenshot}`,
                      )
                    }
                  />
                </div>
              )}
            </div>
            {previewImage && (
              <div
                className="popup-overlay"
                onClick={() => setPreviewImage(null)}
              >
                <div
                  className="image-modal-content"
                  onClick={(e) => e.stopPropagation()}
                >
                  <button
                    className="image-close-btn"
                    onClick={() => setPreviewImage(null)}
                  >
                    ✖
                  </button>

                  <img
                    src={previewImage}
                    alt="Payment Full"
                    className="full-payment-image"
                  />
                </div>
              </div>
            )}

            <div className="description-box">
              <label>Description</label>

              <p>{viewData.description}</p>
            </div>

            <div className="popup-images">
              {viewData.images?.map((img, i) => (
                <img
                  key={i}
                  src={`${UPLOADS.WORKSPACE_IMAGE}${img}`}
                  alt="workspace"
                />
              ))}
            </div>
          </div>
        </div>
      )}
      {renewPopup && (
        <div className="popup-overlay">
          <div className="popup-box renew-popup">
            <div className="popup-header">
              <h3>Renew Ads</h3>

              <button
                className="close-icon-btn"
                onClick={() => setRenewPopup(false)}
              >
                ✕
              </button>
            </div>

            <div className="workspace-grid">
              {/* PLAN */}
              <div className="workspace-field">
                <label>Select Plan</label>

                <select
                  name="show_ads_days"
                  value={renewData.show_ads_days}
                  onChange={handleRenewChange}
                >
                  <option value="">Select Days</option>

                  {adsPlans.map((plan) => {
                    const isFreePlan = String(plan.days) === "3";

                    const isDisabled =
                      isFreePlan &&
                      Number(viewData?.workspace_free_plan_used) === 1;

                    return (
                      <option
                        key={plan.id}
                        value={plan.days}
                        disabled={isDisabled}
                      >
                        {plan.days} Days - ₹{plan.amount}
                        {isDisabled ? " (Already Used)" : ""}
                      </option>
                    );
                  })}
                </select>
              </div>

              {/* AMOUNT */}
              <div className="workspace-field">
                <label>Amount Pay</label>

                <input value={renewData.ads_amount} readOnly />
              </div>

              {/* QR */}
              {renewData.show_ads_days && renewData.ads_amount !== "0" && (
                <div className="workspace-field">
                  <label>Scan & Pay</label>

                  <img src="/images/payment1.png" width="200" />
                  <p className="pay">OR</p>
                  <img src="/images/payment2.png" width="200" />
                </div>
              )}

              {/* SCREENSHOT */}
              {renewData.show_ads_days && renewData.ads_amount !== "0" && (
                <div className="workspace-field">
                  <label>Upload Payment Screenshot</label>

                  <input
                    type="file"
                    name="payment_screenshot"
                    onChange={handleRenewChange}
                  />
                </div>
              )}

              {/* BUTTON */}
              <div className="workspace-field">
                <button
                  className="workspace-submit"
                  onClick={handleRenewSubmit}
                >
                  Renew Ads
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
